import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { FilterRequest, Response, OfferType } from '@core/api';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class OfferTypeService {
  constructor(private http: HttpClient) { }

  list(request?: FilterRequest): Observable<Response<OfferType[]>> {
    return this.http.post<Response<OfferType[]>>(environment.apiUrl + '/api/OfferType/List', request);
  }
}
